import { computed, toValue, type MaybeRefOrGetter } from 'vue'

import {
  RIGHT_ASIDE_WIDTH_STORAGE_KEY,
  useAsideWidth,
} from '../use-aside-width'

export const useRightAsideWidth = () => useAsideWidth(RIGHT_ASIDE_WIDTH_STORAGE_KEY)

/** Binding for `v-resize` + `:style` on desktop right chat asides (shared width singleton). */
export const useRightAsideResizeBinding = (enabled: MaybeRefOrGetter<boolean>) => {
  const {
    widthPx,
    isManualWidth,
    asideWidthStyle: widthStyle,
    setManualWidth,
    previewWidth,
    resetToDefault,
    minWidthPx,
    maxWidthPx,
  } = useRightAsideWidth()

  const resizeOptions = computed(() => {
    if (!toValue(enabled)) return false
    return {
      initialWidth: widthPx.value,
      minWidth: minWidthPx,
      maxWidth: maxWidthPx,
      onResize: previewWidth,
      onResizeEnd: setManualWidth,
      onReset: resetToDefault,
    }
  })

  const asideWidthStyle = computed(() => (toValue(enabled) ? widthStyle.value : undefined))

  return {
    widthPx,
    isManualWidth,
    asideWidthStyle,
    resizeOptions,
    setManualWidth,
    previewWidth,
    resetToDefault,
    minWidthPx,
    maxWidthPx,
  }
}
